<template>
  <div
    class="modal-card has-background-white"
    style="width: 70%; height: 100%; margin: 30px 80px">
    <div class="row-width-actions-bar is-margin-bottom-small">
      <div class="columns is-gapless is-vcentered is-border-bottom">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">{{ params.title || 'Documents' }}</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <div class="modal-card-body columns is-variable is-2 is-multiline has-background-white is-padding-top-xxsmall">
      <div class="column is-12 is-8-widescreen is-8-fullhd is-paddingless-bottom is-margin-bottom-small is-padding-right-small">
        <section
          id="gotop2">
          <div class="notification has-background-red-light is-marginless is-min-height-75 is-flex">
            <div class="is-self-centered w100 has-text-weight-light is-size-7 has-text-weight-medium">
              Merci de renseigner les informations attendues pour valider votre demande de réservation
            </div>
          </div>
          <div
            v-if="checkDoublon && Object.keys(checkDoublon).length !== 0"
            class="has-background-danger">
            <div class="has-text-white margin-left is-size-7 is-padding-top-xsmall is-padding-bottom-xsmall">
              <i>DONNÉES SIMILAIRES DÉTECTÉES SUR : </i>
              <a
                v-if="checkDoublon.duplicate_risk"
                class="is-size-7 has-text-white">
                <span> BASE DÉNONCIATION </span>
                <a class="hover-text">
                  <span class="is-size-7 has-text-white">(<a class="is-size-7 has-text-white">{{ checkDoublon.duplicate_risk || 0 }}/3 </a><i class="fas fa-info-circle"></i>)</span>
                  <span
                    class="tooltip-text"
                    id="top">{{ messages[checkDoublon.duplicate_risk - 1] }}</span>
                </a>
              </a>
              <a
                v-if="checkDoublon.all_pk_contact"
                class="is-size-7 has-text-white is-padding-left-xsmall">
                <span> BASE CONTACT </span>
                <a class="hover-text">
                  <span class="is-size-7 has-text-white">(<a class="is-size-7 has-text-white">{{ checkDoublon.all_pk_contact_risk || 0 }}/3 </a><i class="fas fa-info-circle"></i>)</span>
                  <span
                    class="tooltip-text"
                    id="top">{{ messages_2[checkDoublon.all_pk_contact_risk - 1] }}</span>
                </a>
              </a>
            </div>
          </div>
          <form class="columns is-multiline is-margin-top">
            <div class="column is-12">
              <div class="field">
                <r-label
                  :is-required="true"
                  :red-check="true"
                  :label="'Nature du contact'"
                  :value="contact.nature"></r-label>
                <div class="control">
                  <div class="columns is-variable is-2 is-multiline is-vcentered">
                    <div class="column is-4">
                      <input
                        id="nature_human"
                        type="radio"
                        name="nature"
                        value="human"
                        v-model="contact.nature"
                        class="vadCheckradiocase is-primary is-fullwidth"
                        :class="{'is-active' : contact.nature === 'human'}">
                      <label
                        id="nature_human"
                        for="nature_human">Personne physique</label>
                    </div>
                    <div class="column is-4">
                      <input
                        id="nature_corporation"
                        type="radio"
                        name="nature"
                        value="corporation"
                        v-model="contact.nature"
                        class="vadCheckradiocase is-primary is-fullwidth"
                        :class="{'is-active' : contact.nature === 'corporation'}">
                      <label
                        id="nature_corporation"
                        for="nature_corporation">Personne morale</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="!isHuman && isCorporation"
              class="column is-6">
              <v-input
                id="corporation_name"
                name="corporation_name"
                @input="contact.corporation_name = $event"
                :model="contact.corporation_name"
                v-validate="'min:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Nom société">
                <r-label
                  slot="label"
                  :is-required="true"
                  :red-check="true"
                  :label="'Nom société'"
                  :value="contact.corporation_name"></r-label>
              </v-input>
            </div>
            <div
              v-if="!isHuman && isCorporation"
              class="column is-6">
              <v-input
                id="corporation_siret"
                name="corporation_siret"
                @input="contact.corporation_siret = $event"
                :model="contact.corporation_siret"
                v-validate="'min:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="SIRET Société">
                <r-label
                  slot="label"
                  :is-required="true"
                  :red-check="true"
                  :label="'Siret société'"
                  :value="contact.corporation_siret"></r-label>
              </v-input>
            </div>
            <div class="column is-12">
              <div class="field">
                <r-label
                  :is-required="true"
                  :red-check="true"
                  :label="'Civilité'"
                  :value="contact.title"></r-label>
                <div class="control">
                  <div class="columns is-variable is-2 is-multiline is-vcentered">
                    <div class="column is-4">
                      <input
                        :id="'title-m' + viewId"
                        :name="'title-m' + viewId"
                        type="radio"
                        value="m"
                        class="vadCheckradiocase is-primary is-fullwidth"
                        v-model="contact.title">
                      <label :for="'title-m' + viewId">
                        <span class="icon is-size-4 "><i class="fas fa-male"></i></span>M.
                      </label>
                    </div>
                    <div class="column is-4">
                      <input
                        :name="'title-mme' + viewId"
                        :id="'title-mme' + viewId"
                        type="radio"
                        value="mme"
                        class="vadCheckradiocase is-primary is-fullwidth"
                        v-model="contact.title">
                      <label :for="'title-mme' + viewId">
                        <span class="icon is-size-4 "><i class="fas fa-female"></i></span>Mme
                      </label>
                    </div>
                  </div>
                </div>
                <p
                  v-if="errors.has('title')"
                  class="column is-12">
                  La civilité est obligatoire.
                </p>
              </div>
            </div>
            <div class="column is-6">
              <r-label
                :label="'Nom'"
                :value="contact.last_name"
                :is-required="true"
                :red-check="true"></r-label>
              <v-input
                id="last_name"
                name="last_name"
                @input="val => contact.last_name = val"
                :model="contact.last_name"
                data-vv-as="Nom"
                v-validate="'min:2'"
                :errors-bag="errors"
                data-vv-value-path="val">
              </v-input>
            </div>
            <div class="column is-6">
              <r-label
                :label="'Prénom'"
                :value="contact.first_name"
                :red-check="true"></r-label>
              <v-input
                id="first_name"
                name="first_name"
                @input="val => contact.first_name = val"
                :model="contact.first_name"
                v-validate="'min:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Prénom">
              </v-input>
            </div>
            <div class="column columns is-12 is-marginless-bottom">
              <div class="column is-6">
                <r-label
                  :label="'Nom de naissance'"
                  :value="contact.birth_name"
                  :is-required="false"></r-label>
                <v-input
                  id="birth_name"
                  name="birth_name"
                  @input="val => contact.birth_name = val"
                  :model="contact.birth_name"
                  data-vv-as="Nom de naissance"
                  v-validate="'min:2'"
                  :errors-bag="errors"
                  data-vv-value-path="val">
                </v-input>
              </div>
            </div>
            <div class="column is-6">
              <r-label
                :label="'Adresse mail'"
                :value="contact.email"
                :red-check="true"></r-label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-square">
                    <span class="icon"><i class="fas fa-paper-plane"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <v-input
                    id="email"
                    name="email"
                    @input="val => contact.email = val"
                    :model="contact.email"
                    class=""
                    v-validate="'email'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Email">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <phone-input
                :value="contact.phone"
                :placeholder="'Numéro de téléphone'"
                :required="true"
                @input="val => contact.phone = val">
                <r-label
                  slot="label"
                  :label="'Téléphone'"
                  :value="contact.phone"
                  :red-check="true"
                  :truncate="false">
                  <span
                    class="is-padding-left-xsmall"
                    v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                    <i class="fal fa-info-circle"></i>
                  </span>
                </r-label>
              </phone-input>
            </div>
            <div class="column is-12">
              <address-input
                :source="address"
                :red-check="true"
                :is-required="true"
                @update="updateAddress">
              </address-input>
            </div>
            <div class="column is-4">
              <date-picker
                :model="contact.birthday"
                :style-version="2"
                @input="contact.birthday = $event"
                label="Date de naissance"
                :is-required="true"
                :red-check="true"></date-picker>
              <label class="label"></label>
            </div>
            <div class="column is-4">
              <v-input
                id="birthplace"
                name="birthplace"
                @input="contact.birthplace = $event"
                :model="contact.birthplace"
                v-validate="'min:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                :has-addons="true"
                data-vv-as="Lieu de naissance">
                <r-label
                  slot="label"
                  :is-required="true"
                  :red-check="true"
                  :label="'Lieu de naissance'"
                  :value="contact.birthplace"></r-label>
                <p
                  class="control"
                  slot="addonLeft">
                  <a class="button is-square is-static is-border">
                    <span class="icon"><i class="fas fa-map-marker-alt"></i></span>
                  </a>
                </p>
              </v-input>
            </div>
            <div class="column is-4">
              <v-input
                id="nationality"
                name="nationality"
                v-validate="'min:2'"
                @input="contact.nationality = $event"
                :model="contact.nationality"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Nationalité">
                <r-label
                  slot="label"
                  :is-required="true"
                  :red-check="true"
                  :label="'Nationalité'"
                  :value="contact.nationality"></r-label>
              </v-input>
            </div>
            <div class="column is-4">
              <r-label
                :is-required="true"
                :red-check="true"
                label="Situation Familiale"
                :value="contact.family_situation"></r-label>
              <div class="select is-fullwidth">
                <select v-model="contact.family_situation">
                  <option :value="null">
                    Selectionnez
                  </option>
                  <option
                    v-for="s in familySituationList"
                    :value="s.value"
                    :key="s.value">
                    {{ s.label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="column is-4">
              <r-label
                :is-required="isMarriedOrPacsed"
                :red-check="true"
                :label="contact.family_situation === 'pacs' ? 'Régime de PACS' : 'Statut Matrimonial'"
                :value="contact.matrimonial_status"></r-label>
              <div class="select is-fullwidth">
                <select
                  v-model="contact.matrimonial_status"
                  :disabled="!['married', 'pacs'].includes(contact.family_situation) || contact.family_situation === null">
                  <option :value="null">
                    Selectionnez
                  </option>
                  <option
                    v-for="s in matrimonalStatusList"
                    :value="s.value"
                    :key="s.value">
                    {{ s.label }}
                  </option>
                </select>
              </div>
            </div>
            <div
              class="column is-4">
              <r-label
                slot="label"
                :is-required="false"
                label="Nombre d'enfant"
                :value="contact.children"></r-label>
              <div class="select is-fullwidth">
                <select v-model="contact.children">
                  <option :value="null">
                    Selectionnez
                  </option>
                  <option
                    v-for="i in 11"
                    :key="i"
                    :value="i - 1">
                    {{ i - 1 }}
                  </option>
                </select>
              </div>
            </div>
            <div
              v-for="(child, i) in childrenNumber"
              :key="i"
              class="column is-4">
              <div>
                <date-picker
                  :model="contact.children_date[i]"
                  :style-version="2"
                  @input="contact.children_date[i] = $event"
                  :label="`Date de naissance enfant ${i + 1}`"
                  :is-required="false"></date-picker>
                <label class="label"></label>
              </div>
            </div>
            <div
              class="column is-4"
              v-if="['married', 'pacs'].includes(contact.family_situation)">
              <date-picker
                :model="contact.wedding_date"
                @input="contact.wedding_date = $event"
                :style-version="2"
                :is-required="isMarriedOrPacsed"
                :red-check="true"
                :label="contact.family_situation === 'married' ? 'Date du mariage' : 'Date du PACS'"></date-picker>
            </div>
            <div
              class="column is-4"
              v-if="['divorced'].includes(contact.family_situation)">
              <date-picker
                :model="contact.divorce_date"
                :style-version="2"
                @input="contact.divorce_date = $event"
                :is-required="false"
                :label="contact.family_situation === 'divorced' ? 'Date de divorce' : null"></date-picker>
              <label class="label"></label>
            </div>
            <div
              class="column is-4"
              v-if="['married', 'pacs'].includes(contact.family_situation)">
              <v-input
                id="wedding_place"
                name="wedding_place"
                @input="contact.wedding_place = $event"
                :model="contact.wedding_place"
                :errors-bag="errors"
                v-validate="'min:2'"
                data-vv-value-path="val"
                :data-vv-as="contact.family_situation === 'married' ? 'Lieu du mariage' : 'Lieu du PACS'"
                :has-addons="true">
                <r-label
                  slot="label"
                  :is-required="isMarriedOrPacsed"
                  :red-check="true"
                  :label="contact.family_situation === 'married' ? 'Lieu du mariage' : 'Lieu du PACS'"
                  :value="contact.wedding_place"></r-label>
                <p
                  class="control"
                  slot="addonLeft">
                  <a class="button is-square is-static is-border">
                    <span class="icon"><i class="fas fa-map-marker-alt"></i></span>
                  </a>
                </p>
              </v-input>
            </div>
            <div
              class="column is-4"
              v-if="['married'].includes(contact.family_situation)">
              <v-input
                id="wedding_notary_name"
                name="wedding_notary_name"
                @input="contact.wedding_notary_data.name = $event"
                :model="contact.wedding_notary_data.name"
                :errors-bag="errors"
                v-validate="'required|min:2'"
                data-vv-value-path="val"
                data-vv-as="Nom du notaire du mariage">
                <r-label
                  slot="label"
                  :is-required="false"
                  :label="'Nom du notaire du mariage'"
                  :value="contact.wedding_notary_data.name"></r-label>
              </v-input>
            </div>
            <div
              class="column is-4"
              v-if="['married'].includes(contact.family_situation)">
              <v-input
                id="wedding_notary_city"
                name="wedding_notary_city"
                @input="contact.wedding_notary_data.city = $event"
                :model="contact.wedding_notary_data.city"
                :errors-bag="errors"
                data-vv-value-path="val"
                :data-vv-as="'Commune du notaire du mariage'"
                :has-addons="true">
                <r-label
                  slot="label"
                  :is-required="false"
                  :label="'Commune du notaire du mariage'"
                  :value="contact.wedding_notary_data.city"></r-label>
                <p
                  class="control"
                  slot="addonLeft">
                  <a class="button is-square is-static is-border">
                    <span class="icon"><i class="fas fa-map-marker-alt"></i></span>
                  </a>
                </p>
              </v-input>
            </div>
            <div class="column is-12">
              <div class="column is-paddingless is-4">
                <v-input
                  id="profession"
                  name="profession"
                  @input="contact.profession = $event"
                  :model="contact.profession"
                  :errors-bag="errors"
                  v-validate="'min:2'"
                  data-vv-value-path="val"
                  data-vv-as="Profession">
                  <r-label
                    slot="label"
                    :is-required="true"
                    :red-check="true"
                    :label="'Profession'"
                    :value="contact.profession">
                  </r-label>
                </v-input>
              </div>
            </div>
          </form>
        </section>
      </div>
      <div class="has-text-centered column is-12 is-4-widescreen is-4-fullhd is-paddingless-bottom">
        <div class="field">
          <upload-file
            :multiple="true"
            @upload="uploadDocument({ files: $event })"
            :placeholder="'Sélectionnez ou déposez documents'"
            :source-documents="contact.documents"
            @deleteDocument="deleteDocuments"
            :show-list="false"></upload-file>
        </div>
        <button
          v-if="checkDoublon && Object.keys(checkDoublon).length !== 0"
          @click="submit"
          class="button is-danger is-uppercase is-fullwidth has-text-white"
          type="submit">
          <span>Confirmez l'enregistrement</span>
        </button>
        <button
          v-else
          @click="check"
          :style="verifBtnEnregistrer ? '' : 'opacity: 0.5; cursor: not-allowed'"
          style="background-image: linear-gradient(to top, #70ab64, #70ab64 99%, #95d288); border: none; color: white; height: 120px; border-radius: 4px; margin-bottom: 10px"
          class="has-text-centered column is-12 has-cursor-pointer">
          <span class="is-uppercase is-size-6 ">Enregistrer</span>
        </button>
        <button
          @click="close()"
          style="border: none; color: #5c5c5c; height: 50px; border-radius: 4px; margin-bottom: 10px"
          class="has-text-centered has-background-light column is-12 is-border has-cursor-pointer">
          <span class="is-uppercase is-size-6 ">Annuler</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, isObject } from 'lodash'
import { DefaultValues } from '@/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'ContactEditPreResaModal',
  mixins: [DefaultValues],
  props: {
    active: {
      type: Boolean,
      required: true
    },
    source: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    },
    params: {
      type: Object
    }
  },
  data () {
    return {
      open: {},
      contact: {},
      address: {},
      viewId: Math.random().toString(16).slice(2, 8),
      childrenNumber: [],
      checkDoublon: {},
      messages: ['Doublon Nom/Prénom', 'Doublon Nom/Prénom et Adresse', 'Doublon Email'],
      messages_2: ['Doublon Nom/Prénom', 'Doublon Nom/Prénom et Adresse', 'Doublon Email']
    }
  },
  computed: {
    ...mapGetters(['currentUserPk', 'isAdmin', 'isPromoteur']),
    isHuman () {
      return this.contact.nature && this.contact.nature === 'human'
    },
    isCorporation () {
      return this.contact.nature && this.contact.nature === 'corporation'
    },
    sourceContact () {
      return this.source
    },
    isMarriedOrPacsed () {
      return ['married', 'pacs'].includes(this.contact.family_situation)
    },
    verifBtnEnregistrer () {
      if (this.contact.address) {
        if (this.contact.address.city === '' || this.contact.address.line1 === '' || this.contact.address.country === '' || this.contact.address.zip_code === '') return false
      }
      if (this.contact.first_name === '') return false
      if (this.contact.last_name === '') return false
      if (this.contact.phone === '') return false
      if (this.contact.email === '') return false
      if (this.contact.wedding_place === '') return false
      if (!this.contact.address || !this.contact.first_name || !this.contact.last_name || !this.contact.phone || !this.contact.email || !this.contact.birthday ||
      !this.contact.birthplace || !this.contact.nationality || !this.contact.family_situation) {
        return false
      }
      if (['married', 'pacs'].includes(this.contact.family_situation) && (!this.contact.matrimonial_status || !this.contact.wedding_place || !this.contact.wedding_date)) {
        return false
      }
      if (this.contact.title === '') return false
      if (this.contact.profession === null) return false
      else {
        return true
      }
    }
  },
  watch: {
    'contact.children' (v) {
      if (v < this.childrenNumber.length) {
        let i = this.childrenNumber.length - v
        this.contact.children_date.splice(v, i)
      } else if (v > this.childrenNumber.length) {
        for (let i = v - this.childrenNumber.length; i > 0; i--) {
          this.contact.children_date.push(null)
        }
      }
      this.childrenNumber = []
      for (let i = v; i > 0; i--) {
        this.childrenNumber.push(i)
      }
    },
    'contact.last_name' (v) {
      this.checkDoublon = {}
    },
    'contact.first_name' (v) {
      this.checkDoublon = {}
    },
    'contact.email' (v) {
      this.checkDoublon = {}
    }
  },
  created () {
    this.contact = cloneDeep(this.sourceContact)
    if (this.contact.address) {
      this.address = Object.assign({}, this.contact.address)
    }
    if (!this.contact.children_date) this.contact.children_date = []
    if (!this.contact.wedding_notary_data) this.contact.wedding_notary_data = { name: null, city: null }
  },
  methods: {
    updateAddress (address) {
      this.$set(this, 'address', address)
      this.contact.address = this.address
    },
    close () {
      this.$emit('close')
    },
    async check () {
      if (this.contact.address) {
        if (this.contact.address.city === '' || this.contact.address.line1 === '' || this.contact.address.country === '' || this.contact.address.zip_code === '') this.contact.address = null
      }
      if (this.contact.first_name === '') this.contact.first_name = null
      if (this.contact.last_name === '') this.contact.last_name = null
      if (this.contact.phone === '') this.contact.phone = null
      if (this.contact.email === '') this.contact.email = null
      if (this.contact.wedding_place === '') this.contact.wedding_place = null
      if (!this.contact.address || !this.contact.first_name || !this.contact.last_name || !this.contact.phone || !this.contact.email || !this.contact.birthday ||
      !this.contact.birthplace || !this.contact.nationality || !this.contact.family_situation) {
        this.$toasted.global.danger(`Veuillez renseigner les champs obligatoires.`)
      }
      if (['married', 'pacs'].includes(this.contact.family_situation) && (!this.contact.matrimonial_status || !this.contact.wedding_place || !this.contact.wedding_date)) {
        this.$toasted.global.danger(`Veuillez renseigner les champs obligatoires.`)
      }
      let payload = {}
      if (this.contact.user) {
        payload = {
          contact: this.$cleanPayload(this.contact),
          user: this.contact.user.pk
        }
      } else {
        payload = {
          contact: this.$cleanPayload(this.contact)
        }
      }
      let { data } = await this.$api.post(this.$resources.CONTACT_CHECK, payload)
      if (data.duplicates.length !== 0 || data.all_pk_contact.length !== 0) {
        this.checkDoublon = data
        this.$nextTick(function () {
          var container = document.querySelector('#gotop2')
          if (container) {
            container.scrollTo(0, 0)
          }
        })
      } else {
        this.submit()
      }
    },
    async submit () {
      const cleanContact = this.$cleanPayload(this.contact)
      if (Array.isArray(cleanContact.programs) && isObject(cleanContact.programs[0])) {
        cleanContact.programs = [cleanContact.programs[0].pk]
      }
      if (cleanContact.original_program && cleanContact.original_program.pk) {
        cleanContact.original_program = cleanContact.original_program.pk
      }
      try {
        await this.$api.put(this.$resources.CONTACT, this.contact.pk, cleanContact)
        this.$toasted.global.success('Contact modifié')
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
      let results = {
        contact: this.contact,
        index: this.index
      }
      this.$emit('submit', results)
    },
    async uploadDocument (documents) {
      for (let document of documents.files) {
        if (!Array.isArray(document.destination)) {
          document.destination = []
        }
        document.destination.push('reservation')
        this.contact.documents.push(document)
      }
    },
    deleteDocuments (document) {
      let idx = this.contact.documents.findIndex(x => x.filename === document.filename)
      this.contact.documents.splice(idx, 1)
    }
  }
}
</script>
<style>
.margin-left {
  margin-left: 2rem;
}

.tooltip-text {
  visibility: hidden;
  position: absolute;
  z-index: 1;
  width: 100px;
  color: white;
  font-size: 12px;
  background-color:  #474849;
  border-radius: 10px;
  opacity: 0.80;
  padding: 5px 10px 5px 10px;
}

.hover-text:hover .tooltip-text {
  visibility: visible;
}

#top {
  top: -7px;
  left: 105%;
}

.hover-text {
  position: relative;
  display: inline-block;
  font-family: Roboto;
}

.has-background-red-light {
  background-color: #faddde;
}
</style>
